import Tooltip from '@material-ui/core/Tooltip'
import { useState } from 'react'
import { Button } from 'react-admin'
import CopyToClipboard from 'react-copy-to-clipboard'
import styled from 'styled-components'

interface CopyToClipboardButtonProps {
  text: string | undefined
  styles?: string | undefined
  label?: string | undefined
}

const StyledButton = styled(Button)`
  color: #0000ee;
  padding: 0;
  text-transform: none;

  span {
    padding: 0;
  }

  &:hover {
    background-color: transparent;
  }
`

const Wrap = styled.div<{ $styles?: string }>`
  ${(p) => p.$styles}
`

export function CopyToClipboardButton({ text, styles, label = 'Copy' }: CopyToClipboardButtonProps) {
  const [copiedText, setCopiedText] = useState(false)

  function handleCopy() {
    setCopiedText(true)
    setTimeout(() => {
      setCopiedText(false)
    }, 1000)
  }

  return (
    <Wrap $styles={styles}>
      <CopyToClipboard text={text || ''} onCopy={handleCopy}>
        <Tooltip title={copiedText ? 'Copied!' : ''} placement="top">
          {/* @ts-ignore */}
          <StyledButton variant="text" color="primary" label={label} />
        </Tooltip>
      </CopyToClipboard>
    </Wrap>
  )
}
